import { HeadingText } from '@/components/atoms/HeadingText';
import { useFormContext } from '@/components/forms/FormContext';
import {
	type ReplaceVirtuallyFormState,
	StepMap,
	steps,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';
import { isValid } from './state';
import { Step } from '@/components/forms/Step';
import { handleNext } from './routing';
import { useValidateStep } from '@/components/forms/useValidateStep';
import { ReplaceVirtuallyFormActionMap } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/reducer';
import { TextAlert } from '@/components/calculators/TextAlert';
import { IconInfoBubble } from '@/components/icons';
import { WizardBoxRadio } from '@/components/WizardBox';

export interface SystemAgeStepProps {
	testId?: string;
}

const SystemAgeStep = (props: SystemAgeStepProps) => {
	const { testId = 'SystemAgeStep' } = props;
	const { dispatch, state } = useFormContext<
		StepMap,
		ReplaceVirtuallyFormState,
		ReplaceVirtuallyFormActionMap
	>();
	useValidateStep<
		StepMap,
		ReplaceVirtuallyFormState,
		ReplaceVirtuallyFormActionMap
	>(isValid, steps.SystemAge);

	function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
		dispatch({ type: 'UPDATE_SYSTEM_AGE', payload: event.target.value });
	}

	return (
		<div data-testid={testId}>
			<Step<StepMap, ReplaceVirtuallyFormState, ReplaceVirtuallyFormActionMap>
				name={steps.SystemAge}
				onNext={handleNext}
			>
				<HeadingText
					tag="h1"
					size="h2"
					className="mb-10 mt-10 lg:mb-14 lg:mt-20"
					balanced
				>
					What is the approximate age of your system?
				</HeadingText>

				<div className="mx-auto mb-8 grid max-w-screen-lg grid-cols-2 gap-4 lg:mb-10 lg:grid-cols-6 lg:gap-6">
					<WizardBoxRadio
						label="0-5"
						description="years"
						name="systemAge"
						id="0-5-years"
						value="0-5 years"
						checked={state.systemAge.includes('0-5')}
						onChange={handleChange}
					/>
					<WizardBoxRadio
						label="6-10"
						description="years"
						name="systemAge"
						id="6-10-years"
						value="6-10 years"
						checked={state.systemAge.includes('6-10')}
						onChange={handleChange}
					/>
					<WizardBoxRadio
						label="11-15"
						description="years"
						name="systemAge"
						id="11-15-years"
						value="11-15 years"
						checked={state.systemAge.includes('11-15')}
						onChange={handleChange}
					/>
					<WizardBoxRadio
						label="16-20"
						description="years"
						name="systemAge"
						id="16-20-years"
						value="16-20 years"
						checked={state.systemAge.includes('16-20')}
						onChange={handleChange}
					/>
					<WizardBoxRadio
						label="21+"
						description="years"
						name="systemAge"
						id="21+-years"
						value="21+ years"
						checked={state.systemAge.includes('21+')}
						onChange={handleChange}
					/>
					<WizardBoxRadio
						label="?"
						description="not sure"
						name="systemAge"
						id="not-sure"
						value="Not sure"
						checked={state.systemAge.includes('Not sure')}
						onChange={handleChange}
					/>
				</div>
				<TextAlert
					renderIcon={IconInfoBubble}
					title="Why are we asking?"
					text="The age of your system helps us consider system warranties, condition, and efficiency in our estimates."
				/>
			</Step>
		</div>
	);
};

export default SystemAgeStep;
